// extracted by mini-css-extract-plugin
module.exports = {"container":"IconPicker_container__3syI7","icon":"IconPicker_icon__3mZJK"};